import interpolate from "../../assets/js/utils/interpolation";

class ParallaxBlock {

    /**
     * @type {HTMLElement}
     */
    element;

    layers = [];

    /**
     * @type {DOMRect}
     */
    elementRect;

    middlePos;
    middlePosNormalized = 0;

    constructor(el) {
        this.element = el;

        this.initLayers();
        this.loop();
    }

    initLayers() {
        const layersEls = Array.from(this.element.querySelectorAll('.block-parallax-trip__layer'));

        layersEls.forEach(el => {
            this.layers.push({
                el: el.querySelector('.block-parallax-trip__layer-image'),
                scrollFactor: Number(el.dataset.scrollFactor),
            });
        });
    }

    loop() {
        if (!document.body.contains(this.element)) {
            return;
        }
        
        this.update();
        requestAnimationFrame(this.loop.bind(this));
    }

    update() {
        this.elementRect = this.element.getBoundingClientRect();

        if (this.elementRect.top > window.innerHeight) {
            return;
        }

        if (this.elementRect.top + this.elementRect.height < 0) {
            return;
        }

        this.middlePos = interpolate(this.elementRect.top + this.elementRect.height * 0.5, 0, window.innerHeight, -100, 100);
        this.middlePosNormalized += (this.middlePos - this.middlePosNormalized) * 0.6;
        this.layers.forEach(layer => {
            this.moveLayer(layer);
        });
    }

    moveLayer(layer) {
        const coeff = Math.round(this.middlePosNormalized * layer.scrollFactor * 0.1);
        layer.el.style.transform = `translate3d(0, ${coeff}px, 0)`;
    }
};

const initParallaxBlocks = () => {
    const blocks = Array.from(document.querySelectorAll('.block-parallax-trip'));

    blocks.forEach(block => {
        if (block.inited) {
            return;
        }
        block.inited = true;
        new ParallaxBlock(block);
    });
};

initParallaxBlocks();

export default initParallaxBlocks;
